export const en = {
  "lang.choose": "Choose your language",
  "lang.menu": "Language",

  "common.optional": "Optional",
  "common.select": "Select",
  "common.cancel": "Cancel",
  "common.search": "Search {label}…",
  "common.noMatches": "No matches.",
  "common.listSep": ", ",

  "page.subtitle": "Merchant Application",
  "page.referredBy": "Referred by",
  "page.aBlogicAgent": "a BLogic agent",
  "page.checkingLink": "Checking your link…",
  "page.linkUnverifiedTitle": "Couldn't check this link",
  "page.linkUnverifiedBody": "We couldn't confirm this application link right now. Please refresh the page in a moment, or ask your BLogic contact for help.",
  "page.linkInvalidTitle": "Link not valid",
  "page.linkInvalidBody": "This application link is no longer valid. Please ask your BLogic contact for a new one.",
  "page.missingDl": "Please add a photo of your driver's license.",
  "page.missingCheck": "Please add a photo of a voided business check.",
  "page.genericError": "Something went wrong. Please try again.",
  "page.startOverTitle": "Start over?",
  "page.startOverBody": "Everything you've entered on this device will be cleared. This can't be undone.",
  "page.submit": "Submit application",
  "dup.title": "Looks like you already applied",
  "dup.body": "We received an application for {name} on {date}. Is this the same business?",
  "dup.same": "Yes, it's the same — don't submit again",
  "dup.fix": "Yes, and I need to fix my earlier application",
  "dup.new": "No — it's a different location",
  "dup.replaceTitle": "Replace your earlier application?",
  "dup.replaceBody": "This new one will replace the one from {date}.",
  "dup.replaceConfirm": "Yes, replace it",
  "dup.back": "Go back",
  "dup.sameDoneTitle": "You're all set",
  "dup.sameDoneBody": "We already have your application. Your agent will be in touch.",
  "dup.updatedTitle": "Updated — thanks!",
  "dup.updatedBody": "BLogic will review your changes.",

  "done.title": "Application received",
  "done.body": "Thank you. A BLogic representative will be in touch shortly to review your details and complete boarding.",
  "done.reference": "Reference: {id}",
  "done.another": "Submit another application",

  "step.welcome": "Welcome",
  "step.legal": "Legal",
  "step.business": "Business",
  "step.owner": "Owner",
  "step.bank": "Bank",

  "wiz.back": "Back",
  "wiz.continue": "Continue",
  "wiz.submitting": "Submitting…",
  "wiz.saving": "Saving…",
  "wiz.notSaved": "Not saved",
  "wiz.saved": "Saved {time}",
  "wiz.restored": "Restored your draft from {time}.",
  "wiz.startOver": "Start over",
  "wiz.tryAgain": "Try again",

  "file.prompt": "Take a photo or upload",
  "file.scanning": "Scanning…",
  "file.unsupported": "This file type isn't supported",
  "file.uploadedTap": "Uploaded successfully — tap to replace",
  "file.uploadedDrop": "Uploaded successfully — drop a new file or browse to replace",
  "file.dragDrop": "Drag and drop a file here, or",
  "file.browse": "browse",
  "file.limits": "Images or PDF up to {mb} MB",
  "file.previewAlt": "Preview of {name}",
  "file.attached": "Attached: {name}",
  "file.remove": "Remove",
  "file.typeError": "This file type isn't supported. Choose a supported file instead.",
  "file.oneFile": "Drop one file at a time.",
  "file.tooLarge": "That file is {size} MB — the limit is {max} MB. Please use a smaller photo or a lower-resolution scan.",
  "file.reupload": "Upload this file again.",
  "file.previousLead": "You attached {name} last time. Photos aren't kept in your saved progress, so please attach it again.",
  "file.previousDl": "The name, date of birth and address below came from it.",
  "file.previousCheck": "The bank details below came from it.",

  "conv.message": "We couldn't process your {names}. Tap to upload again.",
  "conv.pair": "{a} and {b}",
  "conv.dl": "driver's license",
  "conv.check": "voided check",

  "scan.kept": "Photo attached. We kept the details you already entered.",
  "scan.firstName": "first name",
  "scan.middleName": "middle name",
  "scan.lastName": "last name",
  "scan.dob": "date of birth",
  "scan.address": "address",
  "scan.city": "city",
  "scan.state": "state",
  "scan.zip": "ZIP",
  "scan.routing": "routing #",
  "scan.account": "account #",
  "scan.bankName": "bank name",

  "welcome.title": "Welcome to BLogic Systems",
  "welcome.intro": "Thanks for choosing to work with us. This short application is the first step toward accepting payments. It takes about 5–10 minutes.",
  "welcome.need": "You'll need",
  "welcome.need1": "Business legal name, EIN, and address",
  "welcome.need2": "Owner's SSN, or passport and country if not a U.S. citizen or resident, and home address",
  "welcome.need3": "The principal owner's details",
  "welcome.need4": "Your business bank account details",
  "welcome.start": "Get started",

  "legal.title": "Legal information",
  "legal.subtitle": "Tell us about your business.",
  "legal.legalName": "Corporate / legal name",
  "legal.email": "Email",
  "legal.phone": "Business phone",
  "legal.website": "Website",
  "legal.street": "Street address",
  "legal.zip": "ZIP",
  "legal.state": "State",
  "legal.city": "City",
  "legal.ownershipType": "Ownership type",
  "legal.startDate": "Date business started",
  "legal.ssn": "Social Security Number (SSN)",
  "legal.ssnHint": "Sole proprietors provide an SSN. 9 digits, formatted as XXX-XX-XXXX.",
  "legal.ein": "Employer Identification Number (EIN)",
  "legal.einHint": "9 digits, formatted as XX-XXXXXXX",
  "legal.dbaTitle": "DBA (Doing Business As)",
  "legal.dbaSubtitle": "The customer-facing name, if different from legal.",
  "legal.dbaSame": "Is the DBA the same as your legal name?",
  "legal.dbaYes": "Yes, use legal name",
  "legal.dbaNo": "No, different DBA",
  "legal.dbaName": "Business name (DBA)",
  "legal.dbaNamePlaceholder": "Customer-facing business name",

  "biz.title": "Business",
  "biz.subtitle": "Your processing profile.",
  "biz.estimates": "Processing estimates",
  "biz.monthly": "Total monthly sales ($)",
  "biz.avgTicket": "Average transaction (ticket) amount ($)",
  "biz.maxTicket": "Largest transaction ($)",
  "biz.product": "What do you sell?",
  "biz.productPlaceholder": "Briefly describe your products or services.",

  "owner.title": "Owner information",
  "owner.subtitle": "We verify the identity of the principal owner. Card brand rules require at least 51% combined ownership.",
  "owner.photoLabel": "Take a photo of your driver's license",
  "owner.photoHint": "We'll read your name, date of birth, and address off the photo so you don't have to type them. Review the fields after.",
  "owner.reading": "Reading your license…",
  "owner.failed": "Something went wrong reading your license. Please fill in the fields below manually.",
  "owner.nothingRead": "We couldn't read anything off that photo. Try a clearer, well-lit shot, or fill in the fields below manually.",
  "owner.prefilled": "Pre-filled {fields}. Please review each field and fix anything that's off.",
  "owner.citizenship": "Citizenship",
  "owner.citizenUs": "U.S. citizen or resident",
  "owner.citizenNonUs": "Non-U.S. person",
  "owner.firstName": "First name",
  "owner.middle": "Middle",
  "owner.lastName": "Last name",
  "owner.dob": "Date of birth",
  "owner.jobTitle": "Title",
  "owner.ssn": "Social Security Number",
  "owner.ssnHint": "9 digits, formatted as XXX-XX-XXXX",
  "owner.passport": "Passport number",
  "owner.passportHint": "As printed on the owner's passport (letters and numbers).",
  "owner.passportCountry": "Country of issuance",
  "owner.phone": "Phone",
  "owner.home": "Home address",

  "bank.title": "Business bank account",
  "bank.subtitle": "Where you'll receive deposits and pay processing fees.",
  "bank.photoLabel": "Take a photo of a voided business check",
  "bank.photoHint": "We'll read the routing and account numbers off the bottom of the check. A bank letter on letterhead works too.",
  "bank.reading": "Reading your check…",
  "bank.failed": "Something went wrong reading your check. Please enter the routing and account numbers manually.",
  "bank.nothingRead": "We couldn't read anything off that photo. Try a clearer, well-lit shot, or enter the routing and account numbers manually.",
  "bank.prefilled": "Pre-filled {fields}. Please confirm against your check.",
  "bank.bankName": "Bank name",
  "bank.bankNamePlaceholder": "e.g. Wells Fargo",
  "bank.routing": "Routing number",
  "bank.routingHint": "9 digits.",
  "bank.account": "Account number",
  "bank.accountPlaceholder": "Checking account number",
  "bank.accountHint": "Digits only, up to 17.",
  "bank.accountType": "Account type",
  "bank.separate": "Use a different account for withdrawals",
  "bank.withdrawBank": "Withdraw bank name",
  "bank.withdrawType": "Withdraw account type",
  "bank.withdrawRouting": "Withdraw routing number",
  "bank.withdrawAccount": "Withdraw account number",
  "bank.notes": "Special notes",
  "bank.notesPlaceholder": "Anything else we should know?",
  "bank.notesHint": "Optional. Anything you'd like underwriting to know.",
  "bank.privacy": "Your information is sent securely and reviewed only by a BLogic representative. Nothing is charged or boarded until you've confirmed the details with them.",

  "v.required": "{label} is required.",
  "v.digits": "{label} must be {n} digits.",
  "v.digitsRange": "{label} must be {min}–{max} digits.",
  "v.zip": "{label} must be 5 digits.",
  "v.letters": "{label} may contain letters only.",
  "v.tooLong": "{label} must not exceed {max} characters.",
  "v.amount": "Enter a valid amount.",
  "v.ownershipType": "Choose an ownership type.",
  "v.emailRequired": "An email address is required.",
  "v.emailInvalid": "Enter a valid email address.",
  "v.title": "Select a title.",
  "v.ssnSole": "An SSN is required for a sole proprietor.",
  "v.einRequired": "An EIN is required.",
  "v.ssnRequired": "An SSN is required.",
  "v.passportRequired": "A passport number is required.",
  "v.passportInvalid": "Enter a valid passport number: 5–20 letters or numbers.",
  "v.passportCountryRequired": "Choose the country that issued the passport.",
  "v.dbaRequired": "Enter the DBA name, or choose “{option}”.",

  "lbl.dbaName": "DBA name",
  "lbl.addressLine2": "Address line 2",
  "lbl.dbaStreet": "DBA street address",
  "lbl.dbaCity": "DBA city",
  "lbl.dbaState": "DBA state",
  "lbl.dbaZip": "DBA ZIP",
  "lbl.contactName": "Contact name",
  "lbl.productDescription": "Product description",
  "lbl.middleName": "Middle name",
  "lbl.idNumber": "ID number",
  "lbl.phoneNumber": "Phone number",
  "lbl.mcc": "MCC",
  "lbl.ein": "EIN",
  "lbl.ssn": "SSN",

  "own.Sole Proprietorship": "Sole Proprietorship",
  "own.Partnership": "Partnership",
  "own.General Partnership": "General Partnership",
  "own.Limited Partnership": "Limited Partnership",
  "own.Limited Liability Partnership": "Limited Liability Partnership",
  "own.LLC": "LLC",
  "own.Corporation - Private": "Corporation - Private",
  "own.Corporation - Public": "Corporation - Public",
  "own.Professional Association": "Professional Association",
  "own.Non-Profit": "Non-Profit",
  "own.Political Organization": "Political Organization",
  "own.Government": "Government",
  "own.Trust": "Trust",
  "own.Financial Institution": "Financial Institution",
  "own.Other": "Other",

  "title.Owner": "Owner",
  "title.Co-Owner": "Co-Owner",
  "title.President": "President",
  "title.Vice President": "Vice President",
  "title.Senior Vice President": "Senior Vice President",
  "title.Secretary": "Secretary",
  "title.Corporate Secretary": "Corporate Secretary",
  "title.Secretary/Treasurer": "Secretary/Treasurer",
  "title.CEO": "CEO",
  "title.Controller": "Controller",
  "title.Financial Officer": "Financial Officer",
  "title.General Manager": "General Manager",
  "title.General Partner": "General Partner",
  "title.Limited Partner": "Limited Partner",
  "title.Manager": "Manager",
  "title.Member": "Member",
  "title.Director": "Director",
  "title.Executive Director": "Executive Director",

  "acct.Checking": "Checking",
  "acct.Savings": "Savings",
};
